import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { userClean } from "../../app/actions/userActions";
import { useTranslation } from "react-i18next";
import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { cleanInnovationsPaginatedS, innovationCleanSaved } from "../../app/actions/innovationActions";
import { closeViewModalAction } from "../../app/actions/viewModalActions";
import useActiveSpecialistRole from "../../app/hooks/useActiveSpecialistRole";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsInnovation = ({ page }) => {

  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const [activeIcon, setActiveIcon] = useState(null);
  
  const {
    isRoleSpecialistSelected, isSpecialistFeeder
  } = useSelector((state) => state.userRole.roleLogin);
  const { flowEngineEnabled, canCreate } = useActiveSpecialistRole();
  const canShowCreateButton = flowEngineEnabled ? canCreate : (isRoleSpecialistSelected && isSpecialistFeeder);

  const handleActiveIcon = (icon) => {
    
    if (icon === "new") {
      
      trackEvent({ component: "NewInnovations", event: "NewInnovations-Clicked" });
      dispatch(innovationCleanSaved());
    } else if (icon === "list") {
      
      trackEvent({ component: "ListInnovations", event: "ListInnovations-Clicked" });
    } else if (icon === "view") {
          
          trackEvent({ component: "ViewInnovations", event: "EndUserSearch-Clicked" });
          dispatch(cleanInnovationsPaginatedS());
        }

    dispatch(userClean());
    
    dispatch(closeViewModalAction());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      <DisplayNameAndRole />
      {page === "listInnovation" && canShowCreateButton && (
        <Link
          data-tip
          data-for="newInnovationTip"
          to="/specialist-innovation/new-innovation"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newInnovation" && (
        <Link data-tip data-for="listInnovationTip" to="/specialist-innovation/" className="p-2 bd-highlight" onClick={() => handleActiveIcon("list")}>
          <i className={`fa fa-table fa-2x  ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "viewText" && (
        <Link data-tip data-for="viewTip" to="/end-user-search/" className="p-2 bd-highlight" onClick={() => handleActiveIcon("view")}>
          <i className={`fa fa-arrow-left fa-2x  ${iconActiveStyle("view")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "viewHierarchical" && (
        <Link data-tip data-for="viewTip" to="/client-search-hierarchical/" className="p-2 bd-highlight" onClick={() => handleActiveIcon("view")}>
          <i className={`fa fa-arrow-left fa-2x  ${iconActiveStyle("view")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editInnovation" && (
        <div className="navbar-module-actions">
          <Link data-tip data-for="listInnovationTip" to="/specialist-innovation/" className="p-2 bd-highlight" onClick={() => handleActiveIcon("list")}>
            <i className={`fa fa-table fa-2x  ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>

          {canShowCreateButton && (
            <Link
              data-tip
              data-for="newInnovationTip"
              to="/specialist-innovation/new-innovation"
              className="p-2 bd-highlight"
              onClick={() => handleActiveIcon("new")}
            >
              <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
            </Link>
          )}
        </div>
      )}

      <ReactTooltip id="newInnovationTip" place="left" effect="solid">
        {t("innovation.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listInnovationTip" place="left" effect="solid">
        {t("innovation.page.list")}
      </ReactTooltip>
      <ReactTooltip id="viewTip" place="left" effect="solid">
        {t("view.information.return")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsInnovation;
